// Display name for a wiki category. Wiki directories live on disk
// lowercased (`entities/`, `concepts/`, `summaries/`) but everything
// the user reads should be capitalised. The General bucket
// (null-category pages — `wiki/index.md`, loose root-level pages) has
// two equivalent keys: `'general'` (user-facing URL form) and
// `'_top'` (sidebar's internal sentinel); both render as "General".
// See `categoryBucket.ts` for the shared constants.
//
// Pure function, no Vue dependencies — safe to import from views,
// composables, or test fixtures.
import { GENERAL_BUCKET_LABEL, isGeneralBucket } from './categoryBucket'

export function categoryLabel(raw: string): string {
  if (isGeneralBucket(raw)) return GENERAL_BUCKET_LABEL
  return raw.charAt(0).toUpperCase() + raw.slice(1)
}
